import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import { ServicePackageTermFragmentFragmentDoc } from '../fragments/servicePackageTerm.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type FindServicePackageForStoreQueryVariables = Types.Exact<{
  store_uuid: Types.Scalars['ID'];
}>;


export type FindServicePackageForStoreQuery = { __typename?: 'Query', findServicePackageForStore?: { __typename?: 'ServicePackageTerm', id: string, package_type: Types.ServicePackageType, currency: string, created_at: string, revision: { __typename?: 'ServicePackageRevision', id: string, revision_number: number, min_contract_term_months: number, monthly_service_fee_in_cents: number, onboarding_fee_in_cents: number, ops_order_price_in_cents: number, note?: string | null, created_at: string, created_by?: string | null, allowances: Array<{ __typename?: 'ServicePackageAssetAllowance', id: string, monthly_quantity: number, item: { __typename?: 'ItemType', id: number, name: string } }>, free_checkouts: Array<{ __typename?: 'ServicePackageFreeCheckout', id: string, segment: Types.ContainerTypeSegment, amount: number }> } } | null };


export const FindServicePackageForStoreDocument = gql`
    query findServicePackageForStore($store_uuid: ID!) {
  findServicePackageForStore(store_uuid: $store_uuid) {
    ...ServicePackageTermFragment
  }
}
    ${ServicePackageTermFragmentFragmentDoc}`;

/**
 * __useFindServicePackageForStoreQuery__
 *
 * To run a query within a React component, call `useFindServicePackageForStoreQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindServicePackageForStoreQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindServicePackageForStoreQuery({
 *   variables: {
 *      store_uuid: // value for 'store_uuid'
 *   },
 * });
 */
export function useFindServicePackageForStoreQuery(baseOptions: Apollo.QueryHookOptions<FindServicePackageForStoreQuery, FindServicePackageForStoreQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindServicePackageForStoreQuery, FindServicePackageForStoreQueryVariables>(FindServicePackageForStoreDocument, options);
      }
export function useFindServicePackageForStoreLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindServicePackageForStoreQuery, FindServicePackageForStoreQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindServicePackageForStoreQuery, FindServicePackageForStoreQueryVariables>(FindServicePackageForStoreDocument, options);
        }
export type FindServicePackageForStoreQueryHookResult = ReturnType<typeof useFindServicePackageForStoreQuery>;
export type FindServicePackageForStoreLazyQueryHookResult = ReturnType<typeof useFindServicePackageForStoreLazyQuery>;
export type FindServicePackageForStoreQueryResult = Apollo.QueryResult<FindServicePackageForStoreQuery, FindServicePackageForStoreQueryVariables>;